/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/news_medium'
export default icon
